import { useDispatch, useSelector } from "react-redux";
import "../../styles/navbar.css"
import { setUser } from "../../redux/slices/userSlice";
export default function Navbar() {
    const { user } = useSelector((state) => state.auth)
	const dispatch = useDispatch()
    const userInfo = {}
    let isUserDefault = true
    if(user && user.name) {
        userInfo.name = window.getName(user)
		userInfo.email = user.email
		userInfo.splitName = userInfo.name.split(" ")
		userInfo.initials = userInfo.splitName.length > 1 ? userInfo.splitName[0][0]+userInfo.splitName[1][0] : userInfo.name.slice(0,2)

		userInfo.accountName = user.account.name
		userInfo.accountEmail = user.account.email
		userInfo.plan = window.capitalize(user.account.bundle.name)
		isUserDefault = user.account.default
    }
    const logout = () => {
		dispatch(setUser(null))
		setTimeout(() => window.auth.lock.logout(), 500)
    }
    return <div className="">
        <div className="navbar navbar-default navbar-static-top navbar-main dashboard">
				<div>
					<div className="navbar-header">
						<div className="navbar-brand-title">
							<a className="navbar-brand brand-name logo" href="/dashboard">
								<img src="/images/brand/meterian_logo_white.svg" />
							</a><i className="fas fa-flask" id="experimental-mode" title="Experimental mode"></i>
							<div className="navbar-cobrand navbar-cobrand-divider"></div>
							<div className="navbar-cobrand">
								<div className="logo">
									<img src="/images/brand/co-brand.png" />
								</div>
							</div>
						</div>

					</div>
					{
						user && !isUserDefault?
						<div className="navbar-menu-right">
							<div id="header-info" className="hide-at-loading">
								<div className="account-details">
									<span id="user-info" ><span id="logged-name">{userInfo.name}</span></span>
									<span id="account-info" ><span id="head-email">{userInfo.email}</span></span>
								</div>
								<div className=" visible-sm visible-md visible-lg visible-xl">
									<div className="account-avatar z-10" 
											data-name={userInfo.name}
											data-email={userInfo.email}	
											data-account-name={userInfo.accountName}
											data-account-email={userInfo.accountEmail}
											data-plan={userInfo.plan}
										><span className="account-initials">{userInfo.initials.toUpperCase()}</span>
									</div>
								</div>
							</div>
						</div> :
						null

					}

					<button className="navbar-toggler" type="button" data-toggle="collapse" 
						data-target="#navbar-ex-collapse" aria-controls="navbar-ex-collapse" 
						aria-expanded="false" aria-label="Toggle navigation">
    					<i className="fas fa-bars"></i>
  					</button>

				</div>
			</div>
			<div className="navbar navbar-default navbar-static-top navbar-secondary navbar-secondary-white bg-transparent">
				<div>

					<div className="navbar-offset"></div>
					<div className="navbar-menu">
						<div className="navbar-menu-decoration"></div>
						<ul className="nav navbar-nav">
							<li>
								<a href="/dashboard">Home</a>
							</li>
							<li className="hidden-sm">
								<a href="https://blog.meterian.com" target="_blank" rel="noopener noreferrer">Blog</a>
							</li>
							<li className="hidden-sm meterian-only">
								<a href="/plans#faq" target="_blank" rel="noopener noreferrer">FAQ</a>
							</li>
							<li>
								<a href="/status" target="_blank" rel="noopener noreferrer">Status</a>
							</li>
							<li>
								<a href="https://docs.meterian.io" target="_blank" rel="noopener noreferrer">Docs</a>
							</li>
							<li>
								<a href="/api" target="_blank" rel="noopener noreferrer">API</a>
							</li>
							{ user && !isUserDefault? 
								<li className="login-link ">
									<a onClick={logout} className="logout-button" href="#">Logout</a>
								</li>
								:
								null
							}
						</ul>

					</div>
				</div>
			</div>
    </div>
}